import { motIDs, RuleID } from '@forto-dev/insights-engine-models'

export const useIsSurveyEnabled = (ruleID?: RuleID): boolean => {
  return ruleID ? motIDs.includes(ruleID) : false
}
